// LanguageContext.js
import { createContext, useContext, useState } from "react";
import translations from "./translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // lingua di default inglese
  const [lang, setLang] = useState("en");

  // funzione di traduzione
  const t = (key) => translations[lang][key] ?? key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

// hook personalizzato
export const useLanguage = () => useContext(LanguageContext);